// import React, { Fragment } from 'react';
// import SkeletonLoader from '../../../../components/Loaders/SkeletonLoader';
// import { Box } from '@mui/material';
// import classes from "../markComponents.module.css";
// const items = [
//     { type1: 'text', type2: "text" },
//     { type1: 'text', type2: "text" },
//     { type1: 'text', type2: "text" },
//     { type1: 'text', type2: "text" },
//     { type1: 'text', type2: "text" },
//     { type1: 'text', type2: "text" },
// ]

// const StatsSkeleton = () => {

//     return <Fragment>
//         {items.map((item, index) => {
//             return <Box key={index} className={classes.flexStats} >
//                 <Box className={classes.containSkeletonStat} >
//                     <SkeletonLoader
//                         type={item.type1 || "rounded"}
//                         skeletonWidth={20}
//                         skeletonHeight={20}
//                     />
//                 </Box>
//                 <Box className={classes.containSkeletonStat} >
//                     <SkeletonLoader type={item.type2 || "text"} skeletonWidth={40} />
//                 </Box>

//             </Box>
//         })}
//     </Fragment>

// }

// export default StatsSkeleton;

import React, { Fragment } from "react";
import SkeletonLoader from "../../../../components/Loaders/SkeletonLoader";
import { Box } from "@mui/material";
import classes from "../markComponents.module.css";

const StatsSkeleton = () => {
  return (
    <Fragment>
      {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((item, index) => {
        return (
          <Box
            key={index}
            className={classes.flexStats}
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "4px",
              padding: "12px 16px",
              flex: "1",
              minWidth: "0",
              borderRight:
                index === 5 ? "none" : "1px solid rgba(229, 231, 235, 0.6)",
            }}
          >
            <Box
              className={classes.containSkeletonStat}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <SkeletonLoader
                type="rounded"
                skeletonWidth={20}
                skeletonHeight={20}
                style={{ borderRadius: "50%" }}
              />
              {/* <SkeletonLoader
                type="rounded"
                skeletonWidth={6}
                skeletonHeight={6}
                style={{ borderRadius: "50%" }}
              /> */}
            </Box>
            <Box className={classes.containSkeletonStat}>
              <SkeletonLoader
                type="text"
                skeletonWidth={40}
                skeletonHeight={10}
              />
            </Box>
          </Box>
        );
      })}
    </Fragment>
  );
};

export default StatsSkeleton;
